import * as SaleForecast from './saleForecast';
import * as MaintainSaleForecast from './maintain';

const Actions = {
  ...SaleForecast,
  ...MaintainSaleForecast,
};

export default Actions;
